import { ParametersUnit } from "@/lib/api";
import { formatParameterDisplayValue } from "@/lib/parameters/format-parameter-display-value";

export function renderValue(value?: string | number, unit?: ParametersUnit) {
  return formatParameterDisplayValue(value, unit, { rainDecimals: 2 });
}
